export default __webpack_public_path__ + "static/spotlight-anatomy-light-977ea612de43f93cde21d385d03e7673.png";